<style scoped>
</style>
<template>
    <div style="padding: 0 0;">
        <div style="display: flex;align-items: center;flex-wrap: wrap;" v-if="!loading">
            <div v-for="(item,index) in options.items" :key="index" v-if="!item.vif || item.vif(query)" style="margin-right:10px;margin-bottom: 10px;">
                <Select v-if="item.type=='selection'" :value="item.multi?((query[item.key] && query[item.key].length)? query[item.key].map(i=>{return item.render(i)}):[]) : item.render(query[item.key])" :multiple="item.multi||false" :filterable="item.filterable||false" :clearable="item.clearable||false" @on-change="selectorChanged(item,$event)" :max-tag-count="item['max-tag-count']"
                    :max-tag-placeholder="item['max-tag-placeholder']" :style="`width:${item.width || 240}px`" :placeholder="item.placeholder||'请选择'">
                    <OptionGroup v-if="item.group" v-for="group in Object.keys(item.loader?item.loader():item.selections)" :key="group" :label="group">
                        <Option v-for="(selection,selectionindex) in item.loader?item.loader():item.selections[group]" :value="item.render(selection)" :key="selectionindex">{{item.render(selection)}}</Option>
                    </OptionGroup>
                    <Option v-if="!item.group" v-for="(selection,selectionindex) in item.loader?item.loader():item.selections" :value="item.render(selection)" :key="selectionindex">{{ item.render(selection) }}</Option>
                </Select>
                <!-- <Select v-if="item.type=='selection' && !item.multi" :value="item.render(query[item.key])" :filterable="item.filterable||false" :clearable="item.clearable||false" @on-change="selectorChanged(item,$event)" :style="`width:${item.width || 240}px`" :placeholder="item.placeholder||'请选择'">
                    <Option v-for="(selection,selectionindex) in item.loader?item.loader():item.selections" :value="item.render(selection)" :key="selectionindex">{{ item.render(selection) }}</Option>
                </Select> -->
                <div v-if="item.type=='daterange'" style="display: flex;">
                    <Select v-if="item.riqitypes" v-model="query.riqitype" style="width:100px;margin-right: 10px;" @on-change="riqitypeChanged(item,$event);">
                        <Option v-for="riqitype in item.riqitypes" :value="riqitype" :key="riqitype">{{ riqitype }}</Option>
                    </Select>
                    <DatePicker :value="query.riqi" format="yyyy-MM-dd" @on-change="daterangeChanged(item,$event)" type="daterange" :style="`width:${item.width || 432}px`" placement="bottom-end" :placeholder="item.label||'选择日期范围'" :clearable="item.clearable || false">
                    </DatePicker>
                </div>
                <div v-if="item.type=='text'">
                    <Input v-if="!query[item.key]" :ref="'input:'+item.key" v-model="inputing[item.key]" icon="ios-search" :placeholder="item.placeholder || ''" :style="`width:${item.width || 240}px`" @on-enter="textChanged(item)">
                    </Input>
                    <div v-if="(!!query[item.key])" @click="textEdit(item)" class="jcsb nowrap" :style="`height: 32px;line-height: 32px;margin: 0;width: ${item.width || 240}px;background-color: #f5f5f5;color: #aaa;padding: 0 8px;border-radius: 4px;`">
                        <div>{{query[item.key]}}</div>
                        <Icon type="ios-close-circle" @click.stop="textClear(item)"></Icon>
                    </div>
                </div>
                <div v-if="item.type=='numberrange'">
                    <div v-if="(!!query[item.key] && (query[item.key][0] || query[item.key][1]))" @click="numberrangeEdit(item)">
                        <div v-if="item.label" :style="`height: 32px;line-height: 32px;margin: 0;width: ${item.width || 320}px;background-color:#f5f5f5;color:#aaa;padding: 0 8px;border-radius: 4px;`">
                            <div class="jcsb">
                                <div class="df">
                                    <div :style="`width:${(item.label.length+1) * 16}px;color:#aaa`">{{item.label}}：</div>
                                    <div style="width: 80px;text-align: center;">{{query[item.key][0]?query[item.key][0]:'0'}}</div>
                                    <div style="margin: 0 10px;">~</div>
                                    <div style="width: 80px;text-align: center;">{{query[item.key][1]?query[item.key][1]:'∞'}}</div>
                                </div>
                                <Icon type="ios-close-circle" style="color: #999;" @click.stop="numberrangeClear(item)"></Icon>
                            </div>
                        </div>
                        <div v-else>label required</div>
                    </div>
                    <div v-else>
                        <div v-if="item.label" :style="`height: 32px;line-height: 32px;margin: 0;width: ${item.width || 320}px;border:1px solid #ddd;padding: 0 8px;border-radius: 4px;`">
                            <div class="jcsb">
                                <div class="df">
                                    <div :style="`width:${(item.label.length+1) * 16}px;color:#aaa`">{{item.label}}：</div>
                                    <Input :ref="'input:'+item.key + '_min'" size="small" v-model.number="inputing[`${item.key}_min`]" placeholder="最小值" :border="false" style="width: 80px;text-align: center;background-color: #f1f1f1;" @on-enter="numberrangeChanged(item)">
                                    </Input>
                                    <div style="margin: 0 10px;">~</div>
                                    <Input :ref="'input:'+item.key + '_max'" size="small" v-model.number="inputing[`${item.key}_max`]" placeholder="最大值" :border="false" style="width: 80px;text-align: center;background-color: #f1f1f1;" @on-enter="numberrangeChanged(item)">
                                    </Input>
                                </div>
                                <Icon type="ios-search" style="color: #999;"></Icon>
                            </div>
                        </div>
                        <div v-else>label required</div>
                    </div>
                </div>
                <BaseSelect v-if="item.type=='jigou'||item.type=='gonghuojigou'" :value="query[item.key]" :multiple="item.multi" :type="item.type" :parameter="item.query" :placeholder="item.placeholder" @change="jigouChanged(item,$event)" />
            </div>
        </div>
        <div v-if="options.confirm">
            <Button type="primary" @click="doQuery">查询</Button>
            <Button @click="init">重置条件</Button>
        </div>
        <!-- <Button type="primary" @click="showConditions">按条件筛选</Button> -->
        <!-- <Tag v-if="query.selections" closable @on-close="query.selections=null;loadData()" style="height: 32px;line-height: 32px;margin: 0;">
            仅查看包含在 <span style="color: #20bf64;">{{query.selections.length}}</span> 个已选项中的内容</Tag> -->
    </div>
</template>
<script>
    export default {
        props: {
            options: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                session: this.$store.session,
                query: {},
                inputing: {},
                loading: true,
            }
        },
        mounted() {
            this.init()
            this.loadQuery()
        },
        methods: {
            saveQuery() {
                sessionStorage[`${this.$store.session.zhanghao._id}:query:${this.options.page}`] = JSON.stringify(this.query)
            },
            loadQuery() {
                if (this.options.page) {
                    let savedData = sessionStorage[`${this.$store.session.zhanghao._id}:query:${this.options.page}`]
                    if (savedData) {
                        let data = JSON.parse(savedData)
                        for (let item of this.options.items) {
                            if (item.nocache) continue
                            if (Object.keys(data).indexOf(item.key) != -1) {
                                let value = data[item.key]
                                this.query[item.key] = value
                            }
                        }
                        this.$emit('on-load', this.query)
                    } else {
                        this.$emit('on-load', this.query)
                    }
                }
            },
            init() {
                let query = { init: true }
                // 不再在初始化时过滤vif项，改为在模板中动态显示
                // this.options.items = this.options.items.filter(o => !o.vif || o.vif())
                for (let item of this.options.items) {
                    if (item.default === undefined) {
                        if (item.multi) {
                            item.default = []
                        } else {
                            item.default = null
                        }
                    }
                    query[item.key] = item.default
                    if (item.type == 'selection') {
                        if (item.multi) {
                            if (!item['max-tag-count']) item['max-tag-count'] = 0
                            if (!item['max-tag-placeholder']) {
                                item['max-tag-placeholder'] = (count) => {
                                    return `已选${count}项`
                                }
                            }
                        }
                        if (!item.render) {
                            item.render = (data) => {
                                if (data && data.name) {
                                    return data.name
                                } else {
                                    return data
                                }
                            }
                        }
                        if (item.clearable === undefined) item.clearable = true
                    } else if (item.riqitypes && item.riqitype) {
                        query['riqitype'] = item.riqitype
                    }
                }
                query.options = this.options
                this.query = query
                this.loading = false
                this.inputing = {}
            },
            textChanged(item) {
                this.query[item.key] = this.inputing[item.key]
                this.$set(this.query, item.key, this.query[item.key])
                if (!this.options.confirm) this.doQuery()
            },
            textEdit(item) {
                this.query[item.key] = ''
                // this.inputing[item.key] = ''
                setTimeout(() => {
                    let input = this.$refs[`input:${item.key}`][0]
                    if (input) input.focus()
                }, 200)
                // if (!this.options.confirm) this.doQuery()
            },
            textClear(item) {
                this.query[item.key] = ''
                this.inputing[item.key] = ''
                setTimeout(() => {
                    let input = this.$refs[`input:${item.key}`][0]
                    if (input) input.focus()
                }, 200)
                if (!this.options.confirm) this.doQuery()
            },
            numberrangeEdit(item) {
                this.query[item.key] = null
                // this.inputing[item.key] = ''
                setTimeout(() => {
                    let input = this.$refs[`input:${item.key}_min`][0]
                    if (input) input.focus()
                }, 200)
                // if (!this.options.confirm) this.doQuery()
            },
            numberrangeClear(item) {
                this.query[item.key] = null
                this.inputing[item.key] = ''
                setTimeout(() => {
                    let input = this.$refs[`input:${item.key}_min`][0]
                    if (input) input.focus()
                }, 200)
                if (!this.options.confirm) this.doQuery()
            },
            daterangeChanged(item, value) {
                this.query[item.key] = value
                if (!this.options.confirm) this.doQuery()
            },
            riqitypeChanged(item, value) {
                this.query['riqitype'] = value
                if (!this.options.confirm) this.doQuery()
            },
            selectorChanged(item, value) {
                if (item.loader) item.selections = item.loader()
                let selections = []
                if (item.group) {
                    for (let key of Object.keys(item.selections)) {
                        selections = selections.concat(item.selections[key])
                    }
                } else {
                    selections = item.selections
                }
                if (item.multi) {
                    let result = []
                    for (let i of value) {
                        for (let selection of selections) {
                            if (item.render(selection) == i) {
                                result.push(this.simple(selection, item._fields))
                                break
                            }
                        }
                    }
                    this.query[item.key] = result
                } else {
                    if (value === undefined) {
                        this.query[item.key] = undefined
                    } else {
                        for (let selection of selections) {
                            if (item.render(selection) == value) {
                                this.query[item.key] = this.simple(selection, item._fields)
                                break
                            }
                        }
                    }
                }
                if (item.change) {
                    item.change({ value: this.query[item.key], query: this.query, item })
                }

                if (!this.options.confirm) this.doQuery()
            },
            doQuery() {
                this.$emit('on-query', this.query)
                this.saveQuery()
            },
            jigouChanged(item, value) {
                this.query[item.key] = value
                if (!this.options.confirm) this.doQuery()
            },
            numberrangeChanged(item) {
                this.query[item.key] = [this.inputing[`${item.key}_min`], this.inputing[`${item.key}_max`]]
                if (!this.options.confirm) this.doQuery()
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/common/Query.vue?2d32e7c7